import {Reducer} from "redux";
import {ModalActions} from "../store/modal-action-types";

export interface ModalState {
    loginIsOpen: boolean
}

const initialState: ModalState = {loginIsOpen: false}

export const modalStateReducer: Reducer<ModalState, ModalActions> = (state = initialState, action: ModalActions) => {
    switch (action.type) {
        case "SHOW_LOGIN_MODAL":
            return {...state, loginIsOpen: true}
        case "HIDE_LOGIN_MODAL":
            return {...state, loginIsOpen: false}
        default:
            return state
    }
}